<template>
    <v-container grid-list-md>
        <form v-on:submit.prevent="create">

            <v-layout row wrap>
                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.to"
                            :error-messages="errors.collect('data.to')"
                            label="To"
                            data-vv-name="data.to"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.vat"
                            :error-messages="errors.collect('data.vat')"
                            label="Vat"
                            data-vv-name="data.vat"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-menu
                            :close-on-content-click="false"
                            v-model="menu"
                            :nudge-right="40"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                    >
                        <v-text-field
                                v-validate="'required'"
                                slot="activator"
                                v-model="data.date"
                                :error-messages="errors.collect('data.date')"
                                label="Date"
                                data-vv-name="data.date"
                                readonly
                                browser-autocomplete="off"
                        ></v-text-field>
                        <v-date-picker v-model="data.date" @input="menu = false"></v-date-picker>
                    </v-menu>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="''"
                            v-model="data.customer_code"
                            :error-messages="errors.collect('data.customer_code')"
                            label="Customer code"
                            data-vv-name="data.customer_code"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.from"
                            :error-messages="errors.collect('data.from')"
                            label="From"
                            data-vv-name="data.from"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-text-field
                        v-if="! last"
                        v-validate="'required'"
                        v-model="data.our_order_number"
                        :error-messages="errors.collect('data.our_order_number')"
                        label="Our order number"
                        data-vv-name="data.our_order_number"
                        browser-autocomplete="off"
                    ></v-text-field>

                    <v-text-field
                        v-if="last"
                        v-validate="'required'"
                        v-model="data.our_order_number"
                        :error-messages="errors.collect('data.our_order_number')"
                        label="Our order number"
                        data-vv-name="data.our_order_number"
                        :hint="'Last sample request: ' + last"
                        persistent-hint                        
                        browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.client_order_number"
                            :error-messages="errors.collect('data.client_order_number')"
                            label="Client order number"
                            data-vv-name="data.client_order_number"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.delivery_terms"
                            :error-messages="errors.collect('data.delivery_terms')"
                            label="Delivery terms"
                            data-vv-name="data.delivery_terms"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="''"
                            v-model="data.to_2"
                            :error-messages="errors.collect('data.to_2')"
                            label="To"
                            data-vv-name="data.to_2"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.payment_terms"
                            :error-messages="errors.collect('data.payment_terms')"
                            label="Payment terms"
                            data-vv-name="data.payment_terms"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.currency"
                            :error-messages="errors.collect('data.currency')"
                            label="Currency"
                            data-vv-name="data.currency"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-autocomplete
                            v-model="data.cliente_id"
                            :items="clients"
                            label="Client"
                            item-text="company_name"
                            item-value="id"
                            v-on:change="debouncedRellenarCampos()"
                            browser-autocomplete="off"
                    >
                    </v-autocomplete>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.concept"
                            :error-messages="errors.collect('data.concept')"
                            label="Concept"
                            data-vv-name="data.concept"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <!--<v-flex xs6 s6 md6>
                    <v-autocomplete
                            v-model="data.status_id"
                            :items="statuses"
                            label="Status"
                            item-text="name"
                            item-value="id"
                    >
                    </v-autocomplete>
                </v-flex>-->

                <v-flex xs12 s12 md12>
                    <v-btn large color="secondary" class="text--primary" type="submit">Create Order confirmation</v-btn>
                    <v-btn outline color="red" v-if="message_error">{{ message_error}}</v-btn>
                </v-flex>
            </v-layout>
        </form>
    </v-container>
</template>

<script>
    import { DICCIONARIO } from '../../../diccionario';

    export default {
        data : function() {
            return {
                data : {
                    date : '',
                    to: '',
                    vat: '',
                    customer_code: '',
                    from: 'Murcia, Spain',
                    client_order_number: '',
                    currency: '',
                    cliente_id: '',
                    concept: '',
                    our_order_number: '',
                    delivery_terms: '',
                    to_2: '',
                    payment_terms: '',
                    status_id: 5,
                },
                menu:false,
                error : false,
                message_error : null,
                clients: null,
                statuses: null,
                last: null
            }
        },
        mounted () {
            this.$validator.localize('en', DICCIONARIO)
        },
        created () {
            this.getStatuses();
            this.setSectionTitle();
            this.getClients();
            this.getLast();
            this.debouncedRellenarCampos = _.debounce(this.rellenarCampos, 100);

        },
        methods: {
            getLast () {
                this.$store.dispatch('getLastOrder', {
                    id: this.data.client_id
                }).then((res) => {
                    this.last = res.data.last_request;

                    this.data.our_order_number = res.data.sugerencia;

                }).catch((error) => {

                });
            },
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Create order confirmation.'
                });
            },
            getClients () {
                this.$store.dispatch('getClientsSelect').then((res) => {
                    this.clients = res.data;
                }).catch((error) => {

                });
            },
            create : function() {

                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.error_login = false;
                        this.message_error_login = '';

                        //dispatch the login and catch the response with the promise declared in vuex Authmodule
                        this.$store.dispatch('createOrder', {
                            data : this.data
                        }).then((res) => {

                            this.$router.push({ name : 'admin.orders.detail', params: { id: res.data.order.id }, query: { model: 'tab-info' }});

                        }).catch((error) => {
                            //if incorrect we show a message
                            this.error_login = true;
                            this.message_error_login = error.data.message;
                        });
                    }
                });

            },
            rellenarCampos () {
                this.$store.dispatch('getClient', {
                    id: this.data.cliente_id
                }).then((res) => {
                    var state = res.data.state_name;
                    var billing = res.data.billing_data_default ? res.data.billing_data_default.billing_data : null;
                    var country = res.data.country_name;

                    if (state == '' && billing == null && country == '') {
                        this.data.to = res.data.company_name + '.';
                    }

                    if (state != '' && billing == null && country == '') {
                        this.data.to = res.data.company_name + ', ' + state + '.';
                    }

                    if (state == '' && billing == null && country != '') {
                        this.data.to = res.data.company_name + ', ' + country + '.';
                    }

                    if (state != '' && billing == null && country != '') {
                        this.data.to = res.data.company_name + ', ' + state +  ', ' + country + '.';
                    }

                    if (state == '' && country == '' && billing != null) {
                        this.data.to = res.data.company_name + ', ' + billing + '.';
                    }

                    if (country == '' && state != '' && billing != null) {
                        this.data.to = res.data.company_name + ', ' + billing + ', ' + state + '.';
                    }

                    if (state == '' && country != '' && billing != null) {
                        this.data.to = res.data.company_name + ', ' + billing + ', ' + country + '.';
                    }

                    if (state != '' && country != '' && billing != null ) {
                        this.data.to = res.data.company_name + ', ' + billing + ', ' + state + ', ' + res.data.country_name + '.';
                    }

                    this.data.vat = res.data.vat;
                }).catch((error) => {

                });
            },
            getStatuses () {
                this.$store.dispatch('getStatusOrders').then((res) => {

                    this.statuses = res.data.data;

                }).catch((error) => {

                });
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/orders/CreateComponent.vue